import {find, forEach} from 'lodash-es';

export default defineNuxtRouteMiddleware((to, from) => {
  const tenant=useTenant();
  const {data: userData} = useAuth();
  if(!tenant || !userData.value) return;

  const currentTenant = find(userData.value.user.tenantsData as any[],{name: tenant});
  if(!currentTenant?.custom_theme) return;

  let cssVariables = '';
  forEach(currentTenant.custom_theme, (value, key) => {
    cssVariables += `--${key}: ${value};`;
  });

  if (import.meta.client) {
    const root = document.documentElement;
    forEach(currentTenant.custom_theme, (value, key) => {
      root.style.setProperty(`--${key}`, value);
    });
  }

  if (import.meta.server) {
    useHead({
      style: [
        {
          children: `:root { ${cssVariables} }`
        }
      ]
    });
  }

  return;
});